export function cutUID(id?: string, start: number = 6, end: number = 6) {
    if (!id) return;
    if (id.length <= 6) return id;
    const UIDStart = id.substring(0, start);
    const UIDEnd = id.substring(id.length - end, id.length);
    return `${UIDStart}...${UIDEnd}`;
}
